export const SORT_KEYS = {
    manual: {
        label: 'Manual',
        compare: () => 0,
    },
    created: {
        label: 'Creation date',
        compare: (a, b) => (a.createdAt || '').localeCompare(b.createdAt || ''),
    },
    due: {
        label: 'Due date',
        compare: (a, b) => (a.dueDate || '').localeCompare(b.dueDate || ''),
    },
};

export const DEFAULT_SORT_KEY = 'manual';
export const DEFAULT_SORT_DIRECTION = 'desc';

export function isValidSortKey(key) {
    return Object.prototype.hasOwnProperty.call(SORT_KEYS, key);
}

export function isValidSortDirection(direction) {
    return direction === 'asc' || direction === 'desc';
}
